var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrill = function SvgDrill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    fillRule: "evenodd",
    d: "M1 6h2s.007.156.025.262c.022.12.06.268.13.435.142.34.4.727.845 1.084C4.878 8.483 6.393 9 9 9h4.22l1.5 6H14a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3v-2.562a2.44 2.44 0 0 0-2.217-2.428L20.281 9H21a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H9c-2.607 0-4.122.517-5 1.22-.445.356-.703.743-.845 1.083-.07.167-.108.316-.13.435A2 2 0 0 0 3 4H1a1 1 0 0 0 0 2m4-.075.001.003c.015.035.07.148.249.291.315.253 1.07.638 2.75.75V3.03c-1.68.112-2.435.497-2.75.75-.18.143-.234.256-.249.291L5 4.075zM10 3v4h3.22a2 2 0 0 1 1.94 1.515l1.5 6A2 2 0 0 1 14.72 17H14a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-2.562a.44.44 0 0 0-.438-.438 1.72 1.72 0 0 1-1.668-1.302L18.34 9.485A2 2 0 0 1 20.28 7H21a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  })));
};
export default SvgDrill;